export default "__VITE_ASSET__CGGbAqwI__"